import React from "react";

import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import Stack, { Row, StackProps } from "@rui/Stack";

export const Wrapper = styled(Row)(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  "&:hover": {
    cursor: "pointer",
  },
  paddingBottom: theme.spacing(2),
}));

type IndicatorProps = StackProps & { active: boolean };
export const Indicator = styled<React.FC<IndicatorProps>>(
  ({ active: _a, ...props }) => (
    <Stack {...props}>
      <Stack className="timeline-item__indicator--active" />
    </Stack>
  )
)(({ active, theme }) => ({
  borderRadius: "50%",
  border: "1px solid",
  borderColor: theme.palette.shades.primary[500],
  height: "16px",
  width: "16px",
  padding: "1px",
  backgroundColor: "#FFF",
  flexShrink: 0,
  "& .timeline-item__indicator--active": {
    borderRadius: "50%",
    backgroundColor: active ? theme.palette.shades.primary[500] : "transparent",
    height: "100%",
    width: "100%",
  },
}));

export const Connector = styled(Stack)(({ theme }) => ({
  width: "1px",
  backgroundColor: theme.palette.shades.neutral[100],
  height: "100%",
  "&.timeline-item__connector--top": {
    height: "8px",
    flexShrink: 0,
  },
  "&.timeline-item__connector--bottom": {
    height: "calc(100% + 24px)",
    marginBottom: theme.spacing(-2),
  },
}));

type TextProps = TypographyProps & { bold?: boolean; compact?: boolean };

export const Text = styled<React.FC<TextProps>>(
  ({ bold: _b, compact: _c, ...props }) => <Typography {...props} />
)(({ bold, compact, theme }) => ({
  ...theme.typography.bodySecondaryReg,
  fontWeight: bold ? 700 : 400,
  color: bold
    ? theme.palette.shades.neutral[800]
    : theme.palette.shades.neutral[600],
  fontFamily: theme.typography.fontFamilySecondary,
  lineHeight: compact ? 1.25 : 21 / 14,
  display: "inline",
}));

type DetailsProps = StackProps & { active: boolean };
export const Details = styled<React.FC<DetailsProps>>(
  ({ active: _a, ...props }) => <Stack {...props} />
)(({ active, theme }) => ({
  overflow: "hidden",
  borderRadius: "8px",
  border: "1px solid",
  borderColor: active
    ? theme.palette.shades.primary[500]
    : theme.palette.shades.neutral[100],
  padding: theme.spacing(1),
  backgroundColor: "#FFF",
  boxShadow: "0px 8px 24px 0px #0000001A",
  width: "100%",
}));
